import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import PromosDataContainer from '../containers/PromosDataContainer';
import { ToastsMessageWrapper as Wrapper } from '../Promos.style';

const pageTop = 50;
const potgTrackingProps = {
    componentName: ['Live'],
    subComponentName: ['Toast Message']
};

const ToastMessageWrapper = ({
    isSingleCol
}) => {
    const [isToastMessageSticky, setToastMessageSticky] = useState(true);
    const [promoRef, setPromoPRef] = useState(null);

    const onScroll = useCallback(() => {
        const windowTop = window.scrollY;
        if (isToastMessageSticky && windowTop < pageTop) {
            setToastMessageSticky(false);
        } else if (!isToastMessageSticky && windowTop > pageTop) {
            setToastMessageSticky(true);
        }
    }, [isToastMessageSticky, setToastMessageSticky]);

    useEffect(() => {
        onScroll();
        window.addEventListener('scroll', onScroll);
        return () => { window.removeEventListener('scroll', onScroll); };
    }, [onScroll]);

    return (
        <>
            <Wrapper isSticky={isToastMessageSticky} ref={setPromoPRef}></Wrapper>
            <PromosDataContainer styleName={isSingleCol ? 'full' : 'narrow'} type={'toast'} portalTarget={promoRef} trackingProps={potgTrackingProps} />
        </>

    );
};

ToastMessageWrapper.propTypes = {
    isSingleCol: PropTypes.bool
};

export default ToastMessageWrapper;
